import { LandSearchType } from '../services/api';

export interface PropertyDetailsRequest {
  id?: string;
  address?: string;
  searchType?: LandSearchType | string;
}
export interface PropertyDetailsResponse {
  data: PropertyDetailsResponseData;
  resultCount: number;
  resultIndex: number;
  recordCount: number;
}

export interface PropertyDetailsResponseData {
  id: string;
  agentNotes?: string;
  mlsNumber?: string;
  mlsDaysOnMarket: number;
  address: PropertyDetailAddress;
  apn: string;
  agentOffice: string;
  lastSaleDate: string;
  lastSaleAmount: string;
  mlsStatus: string;
  lotSquareFeet: number;
  mlsListingPrice: number;
  lastUpdateDate: string;
  mlsHasPhotos: boolean;
  estimatedValue: number;
  latitude: number;
  longitude: number;
  mlsSold: boolean;
}

export interface PropertyDetailAddress {
  address: string;
  city: string;
  county: string;
  state: string;
  street: string;
  zip: string;
}

export interface PropertyDetailMlsHistory {
  agentName: string;
  agentOffice: string;
  agentPhone: string;
  baths: string;
  beds: string;
  daysOnMarket: string;
  lastStatusDate: string;
  price: number;
  propertyId: number;
  seqNo: number;
  status: string;
  statusDate: string;
  type: string;
  agentEmail?: string;
}

export interface GetInTouchRequest {
  sub: string;
  getInTouchReason: GetInTouchOptions;
  apn?: string;
  address?: string;
  freeFormText?: string;
}

export enum GetInTouchOptions {
  HELP_WITH_BUYING_LAND = 'Help with Buying Land',
  HELP_WITH_MORTGAGE_FINANCE = 'Help with Mortgage Finance',
  HELP_WITH_CONSTRUCTION_FINANCE = 'Help with Construction Finance',
  SCHEDULE_PROPERTY_TOUR = 'Schedule Property Tour (retain broker)',
  REQUEST_A_MEETING = 'Request a Meeting ',
}
